import _ from "lodash";
import { useSelector } from "react-redux";

import n2words from "../../../helper/n2words";
import { formatDate, formatMoney } from "../../../helper/formatter";

const formatByKey = (key, value) => {
    switch (key) {
        case "importe":
        case "suma_venta_excenta":
        case "suma_venta_no_sujeta":
        case "retencion":
        case "iva":
        case "suma_venta_sujeta":
        case "subtotal":
            return formatMoney(value);
        case "fecha_emision":
            return formatDate(value);
        default:
            return null;
    }
};

const BuildComprobante = () => {
    const { terceros, talonarios, departamentos, municipios, actividadesEconomicas } = useSelector((state) => ({
        terceros: state.tercero.items,
        talonarios: state.talonario.items,
        departamentos: state.departamento.items,
        municipios: state.municipio.items,
        actividadesEconomicas: state.actividadEconomica.items,
    }));

    return (comprobante) => {
        let tercero = terceros[comprobante.terceroId];
        let talonario = talonarios[comprobante.talonarioId];
        let { name: departamento } = departamentos[tercero.departamentoId] || { name: "" };
        let { name: municipio } = municipios[tercero.municipioId] || { name: "" };

        let { name: actividadEconomica } = actividadesEconomicas[tercero.actividadEconomicaId] || { name: tercero.giro };

        console.log(actividadEconomica);

        let allData = { ...comprobante, ...talonario, ...tercero };
        allData["n_comprobante"] = talonario.serie + allData.n_comprobante;
        allData["subtotal"] = parseFloat(allData.suma_venta_sujeta) + parseFloat(allData.iva);
        allData["fecha_emision.dia"] = formatDate(allData["fecha_emision"], "DD");
        allData["fecha_emision.mes"] = formatDate(allData["fecha_emision"], "MM");
        allData["fecha_emision.mes_letras"] = _.capitalize(formatDate(allData["fecha_emision"], "MMMM"));
        allData["fecha_emision.ano"] = formatDate(allData["fecha_emision"], "YYYY");
        allData["importe_enletras"] = n2words(allData.importe);
        allData["departamento"] = departamento;
        allData["municipio"] = municipio;
        allData["giro"] = actividadEconomica;

        let templateChild = window.open("", "_blank", "width=830,height=780,left=500");
        let template = JSON.parse(talonario.template);

        let attrsItemsChild = _(template)
            .filter((v) => _.startsWith(v.campo, "items."))
            .map((v) => ({ ...v, ["campo"]: v.campo.replaceAll("items.", "") }))
            .value();
        let attrsFijos = _.reject(template, (v) => _.startsWith(v.campo, "items."));

        attrsFijos = _.map(attrsFijos, (t) => {
            let finalData = { ...t, ["data"]: "" };
            if (t.campo != "items" && allData[t.campo]) {
                finalData["data"] = formatByKey(t.campo, allData[t.campo]) || allData[t.campo];
            }
            return finalData;
        });

        let items = _.map(comprobante.detalle_comprobantes, (dc) => {
            dc.cantidad = dc.cantidad ? formatMoney(dc.cantidad, "0,0.[00000]") : "";
            dc.precio_unitario = dc.precio_unitario ? formatMoney(dc.precio_unitario, "$0,0.00[000]") : "";
            dc.venta_sujeta = dc.tipoVentaId == 1 ? formatMoney(dc.venta) : "";
            dc.venta_no_sujeta = dc.tipoVentaId == 2 ? formatMoney(dc.venta) : "";
            dc.venta_excenta = dc.tipoVentaId == 3 ? formatMoney(dc.venta) : "";
            return _.map(attrsItemsChild, (attrI) => {
                return { ...attrI, ["data"]: dc[attrI.campo] || "" };
            });
        });

        let htmlOut = buildTemplate(attrsFijos, items, talonario);
        templateChild.document.write(htmlOut);
        var head = templateChild.document.head || templateChild.document.getElementsByTagName("head")[0];

        let style = document.createElement("style");
        style.innerHTML = `@page{ size: ${talonario.template_witdh}cm 26cm; margin: 0mm; } div {font-size: small;}`;
        head.appendChild(style);

        var stylePrint = document.createElement("style");
        stylePrint.media = "print";
        stylePrint.appendChild(document.createTextNode("@page{  margin: 0; }"));
        head.appendChild(stylePrint);
    };
};

const buildTemplate = (attrs, items, talonario) => {
    let parentNode = document.createElement("body");
    parentNode.style.backgroundImage = `url('/api/file/download/${talonario.template_path}')`;
    parentNode.style.backgroundSize = `${talonario.template_witdh}cm ${talonario.template_height}cm`;
    parentNode.style.backgroundRepeat = `no-repeat`;
    parentNode.style.backgroundColor = "#cccccc";
    parentNode.style.margin = "0";

    _.each(attrs, (attr) => {
        let newDiv = document.createElement("div");
        newDiv.setAttribute("id", attr.campo);
        newDiv.style.position = "fixed";
        newDiv.style.top = attr.top + "cm";
        newDiv.style.left = attr.left + "cm";
        newDiv.style.width = attr.width + "cm";
        if (attr.lineHeight) newDiv.style.lineHeight = attr.lineHeight + "cm";
        newDiv.textContent = attr.data || "";
        if (attr.campo == "items") newDiv.style.display = "table";
        parentNode.appendChild(newDiv);
    });

    _.each(items, (linea) => {
        let newDivItem = document.createElement("div");
        newDivItem.style.display = "table-row";
        _.each(linea, (col, i) => {
            let newDiv = document.createElement("div");
            newDiv.setAttribute("id", `item-${i}-${col.campo}`);
            newDiv.style.display = "table-cell";
            newDiv.style.width = col.width + "cm";
            // newDiv.textContent = col.data || "";
            if (col.lineHeight) newDiv.style.lineHeight = col.lineHeight + "cm";
            newDiv.innerHTML = col.data || "";
            newDivItem.appendChild(newDiv);
        });

        parentNode.querySelector("#items")?.appendChild(newDivItem);
    });

    return parentNode.outerHTML;
};

export default BuildComprobante;
